import React, { useLayoutEffect } from "react";
import "./DarkModeToggle.css";

function detectColorScheme() {
	try {
		if (localStorage["BuzzerDraw-color-scheme"] === "dark") {
			return "dark";
		}
		if (localStorage["BuzzerDraw-color-scheme"] === "light") {
			return "light";
		}
		// eslint-disable-next-line no-empty
	} catch (error) { }

	// window.matchMedia("(prefers-color-scheme: dark)").onchange = (event)=> console.log(event, event.target.matches);
	if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
		// OS theme setting detected as dark
		return "dark";
	}
	// default to light theme
	return "light";
}

export default function DarkModeToggle() {

	// useLayoutEffect rather than useEffect avoids transition from light to dark on page load with dark preference set
	useLayoutEffect(() => {
		document.documentElement.setAttribute("data-color-scheme", detectColorScheme());
	});

	return <button
		className="dark-mode-button"
		aria-label="Toggle Dark Mode"
		onClick={() => {
			localStorage["BuzzerDraw-color-scheme"] = detectColorScheme() === "light" ? "dark" : "light";
			document.documentElement.setAttribute("data-color-scheme", detectColorScheme());
		}}
	>
		<div className="sun-moon">
			<div className="shadow"></div>
		</div>
	</button>;
}

